<template>
  <div class="homePage">
    <!-- <Header activeIndex="/Work" /> -->
    <div>
      <img src="@/assets/image/newsbanner.png" style="width: 100%" alt="" />
    </div>
    <div class="pagew mid">
      <div class="guide">
        <span style="cursor: pointer" @click="back">优秀作品 ></span>
        <span>{{ title }}</span>
      </div>

      <div class="mid-title">
        <div></div>
        <div>{{ title }}</div>
        <div>
          <template v-if="info.workGroup == 1">产品设计组</template>
          <template v-else-if="info.workGroup == 2">创新企业组</template>
          <template v-else-if="info.workGroup == 3">概念设计组</template>
          <template v-else-if="info.workGroup == 4">港澳台赛</template>
          <template v-else>其他</template>
        </div>
      </div>
      <div class="mid-title">
        <!-- <div>2022-05-12</div> -->
        <div>{{ info.workCompetition }}</div>
        <div></div>
        <div>所属单位:{{ info.workUnit }}</div>
      </div>
      <div class="line"></div>
      <!--  内容区    -->
      <div class="content">
        <div class="title">作品简介</div>
        <div class="cont">
          {{ info.workIntro }}
          <!-- "解放双手，动力前行"，POWER+DIVING是一款智能动力潜水的穿戴型装备。以两个S56无轴推进器为动力，外加潜水氧气瓶，集成装备，形成可自由前行的动力系统。POWER+DIVING可穿戴与背部和腹部，腹部背带处的动力
          按键设计可控制前行方向，内置惯导可辅助航行。POWER+DIVING动力背包自由穿戴。提供更高的动力性能，可用于救援、潜水、水上游玩、游泳助力等。 -->
        </div>
        <div class="photo">
          <img src="@/assets/workimg/wd1.png" alt="" style="width: 100%" />
        </div>
        <div class="photo">
          <img src="@/assets/workimg/wd2.png" alt="" style="width: 100%" />
        </div>
        <div class="photo">
          <img src="@/assets/workimg/wd3.png" alt="" style="width: 100%" />
        </div>
        <div class="photo">
          <img src="@/assets/workimg/wd4.png" alt="" style="width: 100%" />
        </div>
        <div class="photo">
          <img src="@/assets/workimg/wd5.png" alt="" style="width: 100%" />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header/Header";
import Footer from "@/components/Footer/index";
export default {
  components: { Footer, Header },
  data() {
    return {
      title: this.$route.query.title,
      info: this.$route.query.info,
    };
  },
  created() {
    // console.log(this.title);
  },
  methods: {
    back() {
      this.$router.push({
        path: "/Work",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.list ::v-deep .el-pagination .el-pager li .active {
  background-color: #25877d !important;
}

.homePage {
  width: 100%;

  .mid {
    padding: 40px 0;
    .guide {
      text-align: start;
      color: #999;
      font-size: 14px;
      .title {
        font-size: 18px;
        font-weight: bold;
        text-align: start;
        margin-top: 35px;
      }
    }
    .mid-title {
      margin-top: 20px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      div {
        width: 33%;
        text-align: start !important;
        font-size: 14px;
      }
    }
    .line {
      width: 100%;
      height: 2px;
      background-color: #f5f5f5;
      margin-top: 20px;
    }
    .content {
      text-align: left;
      .title {
        padding: 20px 0;
      }
      .cont {
        text-align: justify;
        text-indent: 2em;
        font-size: 14px;
        line-height: 25px;
        font-weight: bold;
        margin-bottom: 20px;
      }
      .photo {
        margin-bottom: 30px;
      }
    }
  }

  .el-carousel__item .is-active {
    :deep(.is-active) {
      background-color: red;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Work/wordDetail.vue